import * as Popover from '@radix-ui/react-popover';
import React, { useState } from 'react';
import { Language } from '../../core/i18n/constants';
import { popoverContainers } from '../../core/popovers/popover-containers';
import { AppHeaderButton } from '../app-header-button/app-header-button';
import { LinkButton } from '../link/link';
import TriangleShape from '../shape/assets/triangle-shape.svg?react';
import styles from './language-switcher.module.scss';

export type LanguageSwitcherOption = {
  locale: Language;
  label: string;
};

type Props = {
  options: LanguageSwitcherOption[];
  selectedLocale: Language;
  isLoggedIn: boolean;
  onSelectLocale: (locale: Language) => void;
};

export const LanguageSwitcher: React.FC<Props> = ({ options, selectedLocale, onSelectLocale }) => {
  const [isOpen, setIsOpen] = useState(false);

  const triggerText = selectedLocale.toLocaleUpperCase();

  const handleSelectLocale = (locale: Language) => {
    onSelectLocale(locale);
    setIsOpen(false);
  };

  return (
    <Popover.Root open={isOpen} onOpenChange={setIsOpen}>
      <Popover.Trigger asChild>
        <AppHeaderButton active={isOpen} variant={{ type: 'locale', text: triggerText }} />
      </Popover.Trigger>
      <Popover.Portal container={popoverContainers.general()}>
        <Popover.Content className={styles.content} side="bottom">
          <Popover.Arrow asChild>
            <div className={styles.arrowContainer}>
              <TriangleShape />
            </div>
          </Popover.Arrow>
          {options.map(({ locale, label }) => (
            <LinkButton key={locale} active={selectedLocale === locale} onClick={() => handleSelectLocale(locale)}>
              {label}
            </LinkButton>
          ))}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
